<template>
  <div>
    <HeaderCostQuotation :info="infoCostQuotation" />
    <QuotationSelectInsuranceCompany
      :value="insuranceCompany"
      @selected="updateInsuranceCompany"
      :info="infoCostQuotation"
      :insurance-items="insuranceItems"
      disabled-edit
    >
      <ResumeQuotation :info="infoCostQuotation" @changeView="viewEdit" />
    </QuotationSelectInsuranceCompany>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            outlined
            @click="cancelQuotation"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
          xl="4"
          class="pl-0 pl-sm-5 pb-5 pb-sm-0 pt-sm-5 pt-md-0"
          v-if="canRequestDraftContractSelectedCost"
        >
          <BaseButton
            v-html="'FORMALIZAR COTAÇÃO E SOLICITAR MINUTA'"
            class="white--text secondary"
            width="100%"
            @click="submitRequestDraftContract"
          />
        </v-col>
        <v-col
          cols="12"
          md="5"
          xl="4"
          class="pl-0 pl-sm-5 pb-5 pb-sm-0 pt-sm-5 pt-md-0"
          v-if="canApproveDraftContractSelectedCost"
        >
          <BaseButton
            v-html="'APROVAR MINUTA E SOLICITAR EMISSÃO'"
            class="white--text secondary"
            width="100%"
            @click="submitApproveDraftContract"
          />
        </v-col>
        <v-col
          cols="12"
          sm="5"
          xl="3"
          class="pl-0 pl-sm-5 pb-5 pb-sm-0"
          v-if="canRequestApprovalDraftContractSelectedCost"
        >
          <BaseButton
            v-html="'SOLICITAR APROVAÇÃO MINUTA'"
            class="white--text secondary"
            width="100%"
            @click="submitRequestApproveDraftContract"
          />
        </v-col>
        <!-- <v-col cols="12" sm="5" md="3" class="pl-0 pl-sm-5">
          <BaseButton
            v-html="'SOLICITAR COTAÇÃO'"
            class="white--text secondary"
            width="100%"
            @click="submit"
          />
        </v-col> -->
      </v-row>
    </BaseFooter>
    <ModalGenerateQuote @close="closeModal" v-model="modalQuotation" />
    <ModalDetailsInsuranceCostQuotation
      v-model="modalInsuranceDetailsCost"
      @close="closeInsuranceDetailsCost"
      @submit="submitRequestDraftContract"
    />
    <ModalGenericCriticism
      v-model="modalGeneric"
      @close="closeModalGeneric"
      :title="titleGeneric"
      :text="textGeneric"
    />
  </div>
</template>
<script>
import HeaderCostQuotation from "../components/HeaderCostQuotation";
import ResumeQuotation from "../components/ResumeQuotation";
import QuotationSelectInsuranceCompany from "../components/QuotationSelectInsuranceCompany";
import ModalGenerateQuote from "../components/ModalGenerateQuote";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import PermissionsCost from "@/mixins/PermissionsQuotationAccordingCostMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import ModalGenericCriticism from "../components/ModalGenericCriticism";
import ModalDetailsInsuranceCostQuotation from "../components/ModalDetailsInsuranceQuotation";
export default {
  name: "QuotationStepDeadline",
  data: () => ({
    insuranceCompany: {},
    modalQuotation: false,
    insuranceItems: [],
    modalInsuranceDetailsCost: false,
    modalGeneric: false,
    titleGeneric: null,
    textGeneric: null
  }),
  components: {
    HeaderCostQuotation,
    ResumeQuotation,
    QuotationSelectInsuranceCompany,
    ModalGenerateQuote,
    ModalGenericCriticism,
    ModalDetailsInsuranceCostQuotation
  },
  mixins: [LoadingRequest, QuotationMixin, PermissionsCost, PolicyMixin],
  computed: {
    ...mapState("quotation", ["infoCostQuotation"])
  },
  mounted() {
    this.insuranceCompany = { ...this.form };
    this.fetchInsurance();
  },
  methods: {
    ...mapActions("quotation", [
      "requestAddChosenInsuranceInQuotation",
      "requestInsuranceCompanyQuotation",
      "requestDraftContractQuotation",
      "requestApproveDraftContractQuotation",
      "requestApprovalDraftContractQuotation"
    ]),
    fetchInsurance() {
      this.withLoading(
        this.requestInsuranceCompanyQuotation().then(data => {
          this.insuranceItems = data;
        })
      );
    },
    submit() {
      this.withLoading(
        this.requestAddChosenInsuranceInQuotation(
          this.getPayloadNewCostInQuotation()
        ).then(() => {
          this.modalQuotation = true;
        })
      );
    },
    updateInsuranceCompany(item) {
      this.insuranceCompany = item;
    },
    closeModal(value) {
      this.modalQuotation = false;
      this.$emit("new", value, this.infoCostQuotation.id);
    },
    viewEdit() {
      this.$emit("edit");
    },
    getPayloadNewCostInQuotation() {
      return {
        cotacao: this.infoCostQuotation.id,
        seguradora: this.insuranceCompany.seguradora.id
      };
    },
    cancelQuotation() {
      this.$emit("cancel", this.infoCostQuotation.id);
    },
    closeModalGeneric() {
      this.modalGeneric = false;
      this.$router.push({
        name: "quotation element",
        params: { id: this.infoCostQuotation.id }
      });
    },
    openInsuranceDetailsCost() {
      this.modalInsuranceDetailsCost = true;
    },
    closeInsuranceDetailsCost() {
      this.modalInsuranceDetailsCost = false;
    },
    async submitRequestDraftContract() {
      let payload = {
        cotacao: this.infoCostQuotation.id,
        seguradora: this.insuranceCompany.seguradora.id
      };
      this.withLoading(
        this.requestDraftContractQuotation(payload).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "MINUTA SOLICITADA";
          this.textGeneric = "A minuta foi solicitada com sucesso";
        })
      );
    },
    submitApproveDraftContract() {
      this.withLoading(
        this.requestApproveDraftContractQuotation(
          this.getPayloadNewCostInQuotation()
        ).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "MINUTA APROVADA";
          this.textGeneric =
            "A minuta foi aprovada e a emissão foi solicitada com sucesso";
        })
      );
    },
    submitRequestApproveDraftContract() {
      this.withLoading(
        this.requestApprovalDraftContractQuotation(
          this.getPayloadNewCostInQuotation()
        ).then(() => {
          this.modalGeneric = true;
          this.titleGeneric = "SEGURADORA ESCOLHIDA";
          this.textGeneric = "A seguradora foi escolhida com sucesso";
        })
      );
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
<style lang="sass"></style>
